import { SensorDetailDto } from '@artemis-software/wr-api';

const SYNC_IN_FLIGHT: SensorDetailDto.SensorSyncStatusEnum[] = [
  SensorDetailDto.SensorSyncStatusEnum.Queued,
  SensorDetailDto.SensorSyncStatusEnum.Syncing,
];

const CLEAN_IN_FLIGHT: SensorDetailDto.SensorCleanStatusEnum[] = [
  SensorDetailDto.SensorCleanStatusEnum.Queued,
  SensorDetailDto.SensorCleanStatusEnum.Cleaning,
];

export function isSyncInFlight(sensor: SensorDetailDto): boolean {
  return SYNC_IN_FLIGHT.includes(sensor.sensorSyncStatus);
}

export function isCleanInFlight(sensor: SensorDetailDto): boolean {
  return CLEAN_IN_FLIGHT.includes(sensor.sensorCleanStatus);
}

export function isSensorInFlight(sensor: SensorDetailDto): boolean {
  return isSyncInFlight(sensor) || isCleanInFlight(sensor);
}
